import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { activateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "msisdn",
  "status",
  "plan_id",
  "plan",
  "areacode",
  "zipcode",
  "last_updated",
];

const TmobilejActivateBatch = () => (
  <BatchDetail
    title="Activate"
    apiGet={__getActivate}
    client={CLIENTS.tmobilej}
    columnsFactory={(ctx) => activateColumns({ ...ctx, showPlan: true })}
    copyKeys={COPY_KEYS}
    exportAction="activate"
    retryOperation="activate"
    showTerminate
    getRowPath={(row) => `/tmobilej/activate/${row.id}`}
  />
);

export default TmobilejActivateBatch;
